<template>
  <v-list two-line v-if="invalidEmployeesPPIList && invalidEmployeesPPIList.length > 0">
    <template v-for="(ppi) in invalidEmployeesPPIList">
      <v-list-item :key="ppi">
        <v-row shrink class="col-12">
          <v-list-item-action>
            <img v-if="ppi == 'helmet'" src="/images/epp/casco.png" style="width: 30px;" color="error"/>
            <img v-if="ppi == 'auditoryProtector'" src="/images/epp/protector-auditivo.png" style="width: 30px;" color="error"/>
            <img v-if="ppi == 'securityShoes'" src="/images/epp/calzado-de-seguridad.png" style="width: 30px;" color="error"/>
            <img v-if="ppi == 'gloves'" src="/images/epp/guantes.png" style="width: 30px;" color="error"/>
            <img v-if="ppi == 'goggles'" src="/images/epp/gafas.png" style="width: 30px;" color="error"/>
            <img v-if="ppi == 'gasMask'" src="/images/epp/mascara-de-gas.png" style="width: 30px;" color="error"/>
            <img v-if="ppi == 'uniform'" src="/images/epp/uniforme.png" style="width: 30px;" color="error"/>
            <img v-if="ppi == 'reflectiveVest'" src="/images/epp/chaleco-reflectante.png" style="width: 30px;" color="error"/>
            <img v-if="ppi == 'safetyHarness'" src="/images/epp/arnes-de-seguridad.png" style="width: 30px;" color="error"/>
            <img v-if="ppi == 'weldingMask'" src="/images/epp/mascara-para-soldar.png" style="width: 30px;" color="error"/>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ resx.messages.doesNotHave + resx.labels[ppi] }}</v-list-item-title>
          </v-list-item-content>
        </v-row>
      </v-list-item>
      <v-divider
        v-if="ppi != ppi.length - 1"
        :key="'_' + ppi"
      ></v-divider>
    </template>
  </v-list>
</template>

<script>
"use strict";

import contractorCompanyService from "@/services/ContractorCompanyService";

export default {
  name: "requestAccessPPIDetails",
  methods: {
    getFirstInvalidMessage: contractorCompanyService.getFirstInvalidMessage,
    personalProtectionItemsList() {
      this.invalidEmployeesPPIList
    }
  },
  props: {
    invalidEmployeesPPIList: { type: Array }
  },
};
</script>

<style lang="scss"></style>
